import { Avatar, AvatarProps } from '@mui/material'
import React from 'react'

export type WcAvatarProps = AvatarProps

export const WcAvatar = ({...props}: WcAvatarProps) => (
    <Avatar {...props}/>
  )